export const INIT_PRODUCT_CONFIG_ID = '/EGiftCard/*/InitProductConfigId';
export const LOAD_SELECTED_E_GIFT_CARD = '/EGiftCard/*/LoadSelectedEGiftCard';
export const UPDATE_E_GIFT_CARD_RETAILER = '/EGiftCard/*/UpdateRetailer';
export const UPDATE_E_GIFT_CARD_VALUE = '/EGiftCard/*/UpdateValue';
export const UPDATE_E_GIFT_CARD_USER_DISABLED = '/EGiftCard/*/UpdateEnabledDisabled';
export const STORE_E_GIFT_CARDS = '/EGiftCard/*/StoreEGiftCards';
export const TOGGLE_E_GIFT_CARDS_DRAWER = '/EGiftCard/*/ToggleEGiftCardsDrawer';
